import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { DebugSiteApiService } from '../../core/debug-site';
import { DebugSiteComponent } from './debug-site-card.component';

@NgModule({
  imports: [CommonModule, MatCardModule, TranslateModule, FormsModule, MatSlideToggleModule, MatFormFieldModule],
  declarations: [DebugSiteComponent],
  exports: [DebugSiteComponent],
  providers: [DebugSiteApiService],
})
export class DebugSiteModule {}
